class KlaviyoBackInStockForm extends HTMLElement {
  #submitButton = null;
  #isSubmitting = false;

  connectedCallback() {
    this.#submitButton = this.querySelector('[type="submit"]');

    if (!this.#submitButton) return;
    if (!this.#publicApiKey) return;

    this.#submitButton.addEventListener('click', this.#onFormSubmit);
  }

  disconnectedCallback() {
    this.#submitButton.removeEventListener('click', this.#onFormSubmit);
    this.#submitButton = null;
  }

  get #publicApiKey() {
    return Theme.integrations.klaviyo_public_api_key;
  }

  get #channel() {
    return this.getAttribute('data-channel') ?? 'EMAIL';
  }

  get #emailInput() {
    return this.querySelector('input[type="email"]');
  }

  get #variantIdInput() {
    return this.closest('form')?.querySelector('input[name="id"]')
      ?? this.querySelector('input[name="id"]');
  }

  get #messageElement() {
    return this.querySelector('[data-ref="message"]');
  }

  #onFormSubmit = async (event) => {
    event.preventDefault();

    if (this.#isSubmitting) return;

    const email = this.#emailInput?.value?.trim();
    const variantId = this.#variantIdInput?.value;

    if (!email) {
      this.#renderMessage('error', Theme.strings.klaviyo.errors.email_missing);
      return;
    }

    if (!variantId) {
      this.#renderMessage('error', Theme.strings.klaviyo.errors.generic);
      return;
    }

    this.#setSubmitting(true);

    try {
      const response = await this.#createBackInStockSubscription({ email, variantId });

      if (!response.ok) {
        const data = await response.json();

        console.error('Klaviyo API Create Client Back In Stock Subscription error:', data);

        this.#renderMessage('error',
          data?.errors?.[0]?.detail ?? Theme.strings.klaviyo.errors.generic
        );

        return;
      }

      this.#renderMessage('success', Theme.strings.klaviyo.success.generic);
    } catch (error) {

    }

    finally {
      this.#setSubmitting(false);
    }
  };

  #createBackInStockSubscription({ email, variantId }) {
    const url = `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.#publicApiKey}`;

    const body = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: [
            this.#channel
          ],
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email
              }
            }
          }
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${variantId}`
            }
          }
        }
      }
    };

    return fetch(url, {
      method: 'POST',
      headers: {
        revision: '2026-01-15',
        'content-type': 'application/vnd.api+json'
      },
      body: JSON.stringify(body)
    });
  }

  #setSubmitting(value) {
    this.#isSubmitting = value;

    if (this.#submitButton) {
      this.#submitButton.disabled = value;
    }
  }

  #renderMessage(type, message = '') {
    const element = this.#messageElement;
    if (!element) return;

    element.innerHTML = message;

    element.classList.toggle('text-green-600', type === 'success');
    element.classList.toggle('text-red-600', type === 'error');
    element.classList.toggle('hidden', type === null);
  }
}

if (!customElements.get('klaviyo-back-in-stock-form')) {
  customElements.define('klaviyo-back-in-stock-form', KlaviyoBackInStockForm);
}
